import { Navigate } from "@solidjs/router";
import type { RouteSectionProps } from "@solidjs/router";
import { Show } from "solid-js";
import { isLoggedIn } from "../stores/auth";

export default function AuthGuard(props: RouteSectionProps) {
  return (
    <Show when={isLoggedIn()} fallback={<Navigate href="/auth/login" />}>
      {props.children}
    </Show>
  );
}
